import { Action } from '@ngrx/store';

import { RouterRequestActionType } from './router-request-action-type.enum';

export class RouterBackRequest implements Action {
  public readonly type: RouterRequestActionType = RouterRequestActionType.RouterBackRequest;

  constructor(public readonly payload: void = undefined) { }
}
